import React from "react";
import { Divider } from "./styles.paymentDetails.js";
import { NEGATIVE_AMOUNT_COLOR } from "./statusPalette";

// Sent as the zero value (year 0001) when nothing has been paid yet.
export const isValidDate = (iso) => {
  if (!iso) return false;
  const d = new Date(iso);
  return !Number.isNaN(d.getTime()) && d.getTime() > 0;
};

export const formatFullDate = (iso) =>
  isValidDate(iso)
    ? new Date(iso).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

export const formatMoney = (value, { spaced = false } = {}) => {
  const n = Number(value || 0);
  const sign = n < 0 ? "-" : "+";
  const abs = Math.abs(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });
  return `${sign}${spaced ? " " : ""}₹${abs}`;
};

// A carry-forward payment with a negative amount is deducted from the next payout.
export const CARRY_FORWARD_NOTE = "Will be adjusted in next payout";
export const isCarryForwardAdjustment = (item) =>
  (item.tag || "").toLowerCase() === "carry forward" &&
  Number(item.payout_amount || 0) < 0;

// Inline style that turns a negative amount red, nothing for zero or positive.
export const amountStyle = (value) =>
  Number(value) < 0 ? { color: NEGATIVE_AMOUNT_COLOR } : undefined;

// Resolves to true only when the text really reached the clipboard.
export const copyToClipboard = async (text) => {
  if (!text || !navigator?.clipboard?.writeText) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
};

export const CopyIcon = ({ color = "#293142" }) => (
  <svg width="14" height="14" viewBox="314 119 14 14" fill="none" aria-hidden="true">
    <path
      d="M326.964 123.298C326.936 123.242 326.894 123.186 326.852 123.144L322.848 119.14C322.806 119.098 322.736 119.056 322.666 119.042C322.624 119.014 322.568 119 322.498 119H319.502C318.676 119 318.004 119.672 318.004 120.498V128.996C318.004 129.822 318.676 130.494 319.502 130.494H325.494C326.334 130.494 327.006 129.822 327.006 128.996V123.494C327.006 123.424 326.992 123.354 326.964 123.298ZM323.002 120.708L325.298 122.99H323.17C323.072 122.99 323.002 122.92 323.002 122.836V120.708ZM325.494 129.5H319.502C319.222 129.5 318.998 129.276 318.998 128.996V120.498C318.998 120.218 319.222 119.994 319.502 119.994H321.994V122.836C322.008 123.48 322.526 123.998 323.17 123.998H325.998V128.996C325.998 129.276 325.774 129.5 325.508 129.5H325.494ZM323.002 131.502C323.002 131.768 322.778 131.992 322.498 131.992H316.506C316.226 131.992 316.002 131.768 316.002 131.502V122.99C316.002 122.724 316.226 122.5 316.506 122.5H317.332V121.492H316.506C315.666 121.492 314.994 122.164 314.994 122.99V131.502C314.994 132.328 315.666 133 316.506 133H322.498C323.324 133 323.996 132.328 323.996 131.502V131.166H323.002V131.502Z"
      fill={color}
    />
  </svg>
);

// Places a dashed divider between every pair of items.
export const withDividers = (items) =>
  items.map((item, idx) => (
    <React.Fragment key={item.key}>
      {idx > 0 ? <Divider /> : null}
      {item}
    </React.Fragment>
  ));
